<template>
  <v-menu offset-y>
    <template #activator="{ on: onMenu }">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
      >
        <template  #activator="{ on: onTooltip }">
          <v-btn
            fab
            dark
            small
            :color="color"
            elevation="2"
            v-on="{ ...onMenu, ...onTooltip }"
          >
            <v-icon
              dark
            >
              {{ icon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </template>
    <slot />
  </v-menu>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'BtnMenu',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          target: '_blank',
          icon: undefined,
          subtitle: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      color: {
        type: String,
        default: '#d68f2b',
      },
      icon: {
        type: String,
        default: 'mdi-format-list-bulleted-square',
      },
      tooltip: {
        type: String,
        default: 'Actions - click to show',
      },
      tooltipDelay: {
        type: Number,
        default: 350,
      },
    },

    computed: {
      computedText () {
        if (!this.item || !this.item.title) return ''

        let text = ''

        this.item.title.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return text
      },
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
    },
  }
</script>
